import Reveal from './Reveal';
import SectionHeading from './SectionHeading';
import TradeRoute from './TradeRoute';
import { IMAGES } from '../../data/site';

const CHAPTERS = [
  {
    n: '01',
    title: 'Sourcing',
    text: 'Quality agricultural products sourced with care from reliable Indian origins.',
  },
  {
    n: '02',
    title: 'Quality-Focused Processing',
    text: 'Products prepared and handled in line with buyer requirements and export expectations.',
  },
  {
    n: '03',
    title: 'Documentation',
    text: 'Clear, reliable paperwork prepared for every transaction and destination.',
  },
  {
    n: '04',
    title: 'Long-Term Relationships',
    text: 'Transparent communication built for partnerships that last beyond a single shipment.',
  },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="relative py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <div className="lg:sticky lg:top-28">
          <SectionHeading
            eyebrow="About SKycodeX AgroTech"
            title={
              <>
                Built around quality. <span className="accent-italic font-semibold">Driven by trust.</span>
              </>
            }
          />
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-muted-foreground">
              SKycodeX AgroTech is an India-based agricultural sourcing and export company. We work with buyers who
              value consistent quality, transparent communication and dependable coordination — from product
              selection through to export-ready dispatch.
            </p>
          </Reveal>
          <div className="mt-10">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={0.08 * i}>
                <div
                  data-testid={`about-chapter-${c.n}`}
                  className="group flex items-start gap-6 border-t border-line py-6 transition-colors duration-300 last:border-b hover:bg-white/50"
                >
                  <span className="font-display text-2xl font-semibold text-gold">{c.n}</span>
                  <div>
                    <h3 className="font-display text-xl font-semibold text-ink transition-transform duration-300 group-hover:translate-x-1">
                      {c.title}
                    </h3>
                    <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{c.text}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

      <div className="lg:col-span-6">
        <div className="relative">
          <Reveal>
            <div className="overflow-hidden rounded-[2.5rem] shadow-lift">
              <img
                src={IMAGES.aboutMain}
                alt="Onion harvest at an Indian farm"
                data-testid="about-image"
                loading="lazy"
                className="aspect-[4/5] w-full object-cover transition-transform duration-[1.8s] ease-out hover:scale-105"
              />
            </div>
          </Reveal>
          <Reveal delay={0.15} className="absolute -bottom-10 -left-4 hidden w-52 sm:block lg:-left-10">
            <div className="overflow-hidden rounded-3xl border-4 border-cream shadow-lift">
              <img
                src={IMAGES.aboutField}
                alt="Indian agricultural fields at sunset"
                loading="lazy"
                className="aspect-square w-full object-cover"
              />
            </div>
          </Reveal>
        </div>
        <div className="mt-16 sm:mt-20">
          <TradeRoute />
        </div>
      </div>
    </div>
  </section>
);

export default About;
